import { FilterField } from "~/features/filter";

type Translate = (key: string) => string;

const STATUS_OPTIONS = ["Draft", "Checking", "Verified", "Fixing"];

/**
 * Поля фильтра реестра дилеров: поиск по названию дилера и фильтр по статусу.
 * Имена полей совпадают с историческими ключами URL (searchText/searchTextForSelect),
 * чтобы сохранить обмен параметрами со страницей дилера (/accounting/:period/:id).
 */
export const accountingDealerFilterFields = (t: Translate): FilterField[] => [
  {
    name: "searchText",
    type: "input",
    label: t("accounting.DealerName"),
    placeholder: t("ui.search"),
  },
  {
    name: "searchTextForSelect",
    type: "select",
    label: t("accounting.status"),
    placeholder: t("common.not_selected"),
    options: STATUS_OPTIONS.map((value) => ({
      value,
      label: t(`accounting.${value}`),
    })),
  },
];
